import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT } from '../../../constants/Navigation';
import { getLessonBaseUrl, getTrackBaseUrl } from '../../../utils/RoutingUtils';
import { useFullPlaylist } from '../../savedItems/savedItemsQueries';
import { usePlaylistProgress } from '../../userProgress';
import { usePlaylistIdFromSearch } from '../hooks';
import getLang from 'LearningCenterUI/utils/getLang';
import useNavigate from '../../../hooks/useNavigate';
import { getShortContentUrl } from '../../shortContent/shortContentRouting';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const useRenderParams = ({
  contentType,
  trackId,
  lessonId,
  shortId,
  nextPlaylistItem,
  playlistProgress,
  redirectUrl
}) => {
  const navigate = useNavigate();
  const urlBuilder = suffix => {
    if (contentType === 'TRACK' && trackId) {
      return getTrackBaseUrl(trackId.toString(), suffix);
    } else if (contentType === 'LESSON' && lessonId) {
      return getLessonBaseUrl(lessonId.toString(), suffix);
    } else if (contentType === 'SHORT_FORM_CONTENT' && shortId) {
      return `${getShortContentUrl({
        shortId
      }).fullUrl}/${suffix}`;
    }
    return '';
  };
  const renderParams = {
    urlFragments: PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.incompleteTitle"
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.incompleteSubtitle"
    }),
    url: urlBuilder(TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT),
    language: getLang(),
    navigate: () => {}
  };
  if (playlistProgress && playlistProgress.status === 'COMPLETED') {
    renderParams.title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.completeTitle"
    });
    renderParams.url = urlBuilder(TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT);
  } else if (nextPlaylistItem) {
    const {
      itemId,
      type,
      language: itemLanguage,
      name
    } = nextPlaylistItem;
    renderParams.trackId = type === 'TRACK' ? itemId : undefined;
    renderParams.lessonId = type === 'LESSON' ? itemId : undefined;
    renderParams.shortId = type === 'SHORT_FORM_CONTENT' ? itemId : undefined;
    renderParams.subtitle = name;
    renderParams.language = readUnhandledEnumCase(itemLanguage).toLowerCase();
    if (type === 'SHORT_FORM_CONTENT') {
      // open short directly instead of rendering a short inside a short
      renderParams.url = getShortContentUrl({
        shortId: itemId
      }).fullUrl;
    } else {
      renderParams.url = urlBuilder(TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT);
    }
  }
  if (redirectUrl && !redirectUrl.includes('recommendations')) {
    renderParams.url = redirectUrl;
  }
  const navigateToLastSection = useCallback(() => {
    navigate(location => Object.assign({}, location, {
      pathname: renderParams.url || ''
    }));
  }, [navigate, renderParams.url]);
  renderParams.navigate = navigateToLastSection;
  return renderParams;
};
export const NextPlaylistContent = ({
  trackId,
  lessonId,
  shortId,
  render,
  redirectUrl
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    displayedPlaylistItems
  } = useFullPlaylist(playlistId, !playlistId);
  const {
    playlistProgress
  } = usePlaylistProgress(playlistId);
  const contentType = shortId ? 'SHORT_FORM_CONTENT' : trackId ? 'TRACK' : 'LESSON';
  const nextPlaylistItemIndex = displayedPlaylistItems ? displayedPlaylistItems.findIndex(item => item.itemId === (trackId || lessonId || shortId) && item.type === contentType) + 1 : -1;
  const nextPlaylistItem = displayedPlaylistItems && displayedPlaylistItems[nextPlaylistItemIndex];
  const renderParams = useRenderParams({
    contentType,
    trackId,
    lessonId,
    shortId,
    nextPlaylistItem,
    playlistProgress,
    redirectUrl
  });
  return render(renderParams);
};